import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:7002/api';

// When BASE_URL is a relative path like "/api", SERVER_BASE must be the
// current origin so that resolveUrl() produces absolute URLs for <img> tags
// and other resources that cannot use relative paths reliably.
const _rawBase = BASE_URL.replace(/\/api$/, '');
export const SERVER_BASE = _rawBase === '' || _rawBase === '/'
  ? window.location.origin   // relative build (production via nginx)
  : _rawBase;                // absolute URL (local dev)

/** Resolve a relative /uploads/... path to an absolute URL.
 *  Also rewrites any absolute URL that points to localhost (dev server)
 *  so it works correctly when served from the EC2 production host.
 */
export function resolveUrl(url) {
  if (!url) return '';
  if (url.startsWith('data:')) return url;
  // Rewrite localhost:7002 (or any localhost origin) to the current origin
  if (/^https?:\/\/localhost(:\d+)?\//.test(url)) {
    const withoutOrigin = url.replace(/^https?:\/\/localhost(:\d+)?/, '');
    return `${SERVER_BASE}${withoutOrigin}`;
  }
  if (url.startsWith('http') || url.startsWith('//')) return url;
  return `${SERVER_BASE}${url.startsWith('/') ? '' : '/'}${url}`;
}
const client = axios.create({ baseURL: BASE_URL });

export const setAuthToken = (token) => {
  if (token) {
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete client.defaults.headers.common['Authorization'];
  }
};

let logoutCallback = null;
export const setLogoutCallback = (cb) => { logoutCallback = cb; };

client.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Handle deactivated account — redirect to login with reason
    if (
      error.response?.status === 403 &&
      error.response?.data?.code === 'ACCOUNT_DEACTIVATED'
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      delete client.defaults.headers.common['Authorization'];
      if (logoutCallback) logoutCallback();
      window.location.href = '/login?reason=deactivated';
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      const msg = error.response?.data?.message || '';
      // Only auto-logout on token errors, not on permission errors (403 is separate)
      if (msg === 'Invalid or expired token' || msg === 'No token provided') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete client.defaults.headers.common['Authorization'];
        if (logoutCallback) logoutCallback();
        // Redirect to login
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
